import { render, staticRenderFns } from "./ItemProduto.vue?vue&type=template&id=22ba95d3&scoped=true"
import script from "./ItemProduto.vue?vue&type=script&lang=js"
export * from "./ItemProduto.vue?vue&type=script&lang=js"
import style0 from "./ItemProduto.vue?vue&type=style&index=0&id=22ba95d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba95d3",
  null
  
)

export default component.exports